import { Phone, Mail, MapPin, ArrowUpRight } from "lucide-react";
import Logo from "@/components/Logo";
import { BIZ, BRANDS } from "@/constants/content";

export default function Footer() {
  return (
    <>
      <footer className="relative overflow-hidden bg-abyss pt-16 text-white" data-testid="footer">
        <div className="blueprint-dark absolute inset-0 opacity-40" />
        <div className="relative mx-auto max-w-7xl px-4 pb-28 sm:px-6 lg:px-8 lg:pb-12">
          <div className="grid gap-12 lg:grid-cols-12">
            <div className="lg:col-span-5">
              <Logo light />
              <p className="mt-5 max-w-sm text-[14.5px] leading-relaxed text-white/60">
                Family-run dental handpiece repair from Buffalo, NY. Mobile workshop van across Buffalo, Erie &
                Rochester — plus free WNY pickup and nationwide ship-in.
              </p>
              <div className="mt-6 flex flex-wrap gap-2">
                {BIZ.areas.map((a) => (
                  <span key={a} className="inline-flex items-center gap-1.5 rounded-full border border-white/15 px-3 py-1.5 text-[12px] font-semibold text-white/75">
                    <MapPin className="h-3 w-3 text-brandsky" /> {a}
                  </span>
                ))}
              </div>
            </div>

            <div className="lg:col-span-3">
              <p className="eyebrow text-white/40">Contact</p>
              <div className="mt-4 space-y-3">
                {[BIZ.jacob, BIZ.jonah].map((p) => (
                  <a key={p.name} href={p.tel} className="group flex items-center justify-between" data-testid={`footer-call-${p.name.split(" ")[0].toLowerCase()}`}>
                    <span>
                      <span className="block text-[13.5px] font-bold text-white">{p.name}</span>
                      <span className="text-[12px] text-white/50">{p.role}</span>
                    </span>
                    <span className="font-mono flex items-center gap-2 text-[13.5px] font-bold text-white group-hover:text-brandsky">
                      <Phone className="h-3.5 w-3.5 text-brandsky" />
                      {p.phone}
                    </span>
                  </a>
                ))}
                <a href={`mailto:${BIZ.email}`} className="flex items-center gap-2 text-[13.5px] font-semibold text-white/75 hover:text-white" data-testid="footer-email">
                  <Mail className="h-4 w-4 text-brandsky" />
                  {BIZ.email}
                </a>
              </div>
            </div>

            <div className="lg:col-span-4">
              <p className="eyebrow text-white/40">Brands we service</p>
              <div className="mt-4 flex flex-wrap gap-x-4 gap-y-2">
                {BRANDS.map((b) => (
                  <span key={b} className="text-[13px] font-medium text-white/60">{b}</span>
                ))}
                <span className="text-[13px] font-medium text-white/60">…and more</span>
              </div>
              <a
                href="#intake"
                className="mt-7 inline-flex items-center gap-2 rounded-full bg-white px-6 py-3 text-[13.5px] font-bold text-ink transition-colors hover:bg-brandsky-soft"
                data-testid="footer-intake-button"
              >
                Send an intake <ArrowUpRight className="h-4 w-4" />
              </a>
            </div>
          </div>

          <div className="mt-14 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-6 text-[12px] text-white/40 sm:flex-row">
            <p>© {new Date().getFullYear()} JSL Dental Repair · Buffalo, NY</p>
            <div className="flex items-center gap-4">
              <p>Efficient repairs, brilliant smiles.</p>
              <a href="/admin" className="font-semibold text-white/40 transition-colors hover:text-brandsky" data-testid="footer-office-login">Office login</a>
            </div>
          </div>
        </div>
      </footer>

      <div className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-[1fr_1fr_auto] gap-2 border-t border-ink/10 bg-white/95 p-3 backdrop-blur-xl lg:hidden" data-testid="mobile-call-bar">
        <a href={BIZ.jacob.tel} className="btn-lift flex items-center justify-center gap-2 rounded-xl bg-ink px-3 py-3 text-[13px] font-bold text-white" data-testid="callbar-jacob-button">
          <Phone className="h-4 w-4" /> Call Jacob
        </a>
        <a href={BIZ.jonah.tel} className="btn-lift flex items-center justify-center gap-2 rounded-xl border border-ink/20 bg-white px-3 py-3 text-[13px] font-bold text-ink" data-testid="callbar-jonah-button">
          <Phone className="h-4 w-4 text-brandsky-deep" /> Call Jonah
        </a>
        <a href="#intake" className="btn-lift flex items-center justify-center rounded-xl bg-brandpink px-4 py-3 text-[13px] font-bold text-white" data-testid="callbar-intake-button">
          Intake
        </a>
      </div>
    </>
  );
}